/**
 * <pilame-sticky-atc>
 * Shows a fixed bottom bar on mobile once the main add-to-cart button has
 * scrolled out of view. The bar's button submits the main product form so
 * Dawn's <product-form> handles the AJAX add and cart drawer.
 */
if (!customElements.get('pilame-sticky-atc')) {
  customElements.define(
    'pilame-sticky-atc',
    class PilameStickyAtc extends HTMLElement {
      connectedCallback() {
        this.formId = this.dataset.formId;
        this.button = this.querySelector('.pilame-sticky-atc__button');
        this.mainButton = document.getElementById(this.dataset.watch);
        if (!this.button || !this.mainButton) return;

        this.button.addEventListener('click', this.onClick.bind(this));

        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.setAttribute('data-visible', passed ? 'true' : 'false');
            this.setAttribute('aria-hidden', passed ? 'false' : 'true');
          },
          { threshold: 0 }
        );
        this.observer.observe(this.mainButton);

        // Mirror disabled / sold-out state of the main button
        this.mirror = new MutationObserver(() => this.syncState());
        this.mirror.observe(this.mainButton, { attributes: true, childList: true, subtree: true });
        this.syncState();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mirror) this.mirror.disconnect();
      }

      syncState() {
        const disabled = this.mainButton.hasAttribute('disabled') || this.mainButton.getAttribute('aria-disabled') === 'true';
        this.button.toggleAttribute('disabled', disabled);
        const label = this.mainButton.querySelector('span');
        if (label) this.button.textContent = label.textContent.trim();
      }

      onClick() {
        const form = document.getElementById(this.formId);
        if (!form) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      }
    }
  );
}
